module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-th.5cfd1326aa223ecf8729.svg";